import {
  faArrowUpRight,
  faCodeCompare,
} from "@fortawesome/pro-regular-svg-icons";

import { Button } from "src/base-components/Button";
import { CodeEditor } from "src/base-components/CodeInput/CodeEditor";
import { BeMappedNode } from "src/constants/NodeDataTypes";
import { NODE_TYPE } from "src/constants/NodeTypes";
import { InspectChangesModal } from "src/copilot/InspectChangesModal";
import { NodePill } from "src/copilot/NodePill";
import { useModal } from "src/design-system/Modal";

export type NodeSuggestion = {
  name: string;
  type: NODE_TYPE;
  meta: { src: string };
};

type Props = {
  nodeSuggestion: NodeSuggestion;
  originalNode: BeMappedNode;
  onApply: (suggestion: NodeSuggestion) => void;
};

export const CodeNodeSuggestion: React.FC<Props> = ({
  originalNode,
  nodeSuggestion,
  onApply,
}) => {
  const { isOpen, closeModal, openModal } = useModal();
  const nodeForPill = {
    ...originalNode,
    data: {
      ...originalNode.data,
      label: nodeSuggestion.name,
    },
  };

  return (
    <div className="my-4 rounded-lg border border-gray-200 p-2">
      <div className="pb-2">
        <div className="w-40">
          <NodePill node={nodeForPill} />
        </div>
      </div>

      <div className="min-h-[200px] border-y border-y-gray-100 py-2">
        <CodeEditor
          language="python"
          value={nodeSuggestion.meta.src}
          readOnly
        />
      </div>

      <div className="flex justify-between pt-2">
        <Button
          iconLeft={faCodeCompare}
          size="sm"
          variant="secondary"
          onClick={openModal}
        >
          Inspect changes
        </Button>
        <Button
          iconLeft={faArrowUpRight}
          size="sm"
          variant="secondary"
          onClick={() => onApply(nodeSuggestion)}
        >
          Apply changes
        </Button>
      </div>

      <InspectChangesModal
        isOpen={isOpen}
        nodeSuggestion={nodeSuggestion}
        originalNode={originalNode}
        onClose={closeModal}
      />
    </div>
  );
};
